import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import loginReducer from './slices/Auth/LoginSlice';
import logoutReducer from './slices/Auth/LogoutSlice';
import usersListReducer from './slices/User/UserListSlice';
import searchReducer from './slices/Filters/SearchSlice';
import statusReducer from './slices/Filters/StatusSlice';
import addProductReducer from './slices/Product/AddProductSlice';
import getCategoriesListReducer from './slices/Content/GetCategoriesListSlice';
import getProductTypesListReducer from './slices/Content/GetProductTypesList';
import getUnitsListReducer from './slices/Content/GetUnitsList';
import getSupplierDetailReducer from './slices/User/Detail/SupplierDetailSlice';
import getSupplierProductsReducer from './slices/User/Detail/GetSupplierProductSlice';
import cartReducer from './slices/Cart/CartSlice';
import cartUIReducer from './slices/Cart/CartUISlice';
import getSupplierFilterProducts from './slices/User/Detail/Filters/GetProductSlice';
import getSupplierFilterCategories from './slices/User/Detail/Filters/GetCategorySlice';
import addToCartReducer from './slices/Cart/AddToCartSlice';
import updateUserStatusReducer from './slices/User/UpdateStatusSlice';
import productsAddedToCartReducer from './slices/Cart/GetProductsAddedToCartSlice';
import orderRequestReducer from './slices/Cart/OrderRequestSlice';
import supplierGeneratedOrdersReducer from './slices/Supplier/GetGeneratedOrdersSlice';
import supplierRecievedOrdersReducer from './slices/Supplier/GetRecievedOrdersSlice';
import supplierCompletedOrdersReducer from './slices/Supplier/GetCompletdOrdersSlice';
import productManagementReducer from './slices/Product/GetProductSlice';
import showAddProductButtonReducer from './slices/Product/showAddProductButton';
import menuListReducer from './slices/Menu/GetMenuListSlice';
import AddMenuReducer from './slices/Menu/AddMenuSlice';
import newsAndEventsListReducer from './slices/NewsAndEvents/GetListSlice';
import addNewsAndEventsReducer from './slices/NewsAndEvents/AddNewsAndEventsSlice';
import activeTabReducer from './slices/Content/SetActiveTab';
import categoriesReducer from './slices/Content/GetCategoriesSlice';
import productTypesReducer from './slices/Content/GetProductTypesSlice';
import updateContentReducer from './slices/Content/UpdateContentSlice';
import getContentReducer from './slices/Content/GetContentSlice';
import addCategoryReducer from './slices/Content/AddCategorySlice';
import updateCategoryReducer from './slices/Content/UpdateCategorySlice'
import addProducTypeReducer from './slices/Content/AddProductTypeSlice';
import getQueriesReducer from './slices/Query/GetQueriesSlice';
import sendNotificationReducer from './slices/send-notification/PostNotificationSlice';
import changePasswordReducer from './slices/Profile/ChangePasswordSlice';
import getProfileReducer from './slices/Profile/GetProfileSlice';
import updateProfileReducer from './slices/Profile/UpdateProfileSlice';
import getUsersDataReducer from './slices/Dashboard/userDataSlice';
import ordersForSuppliersReducer from './slices/Dashboard/ordersForSuppliersSlice';
import supplierOrdersDashboardReducer from './slices/Dashboard/supplierOrdersSlice';
import usersCountReducer from './slices/Dashboard/usersCountSlice';
import getOrdersListReducer from './slices/Order/GetOrderList';
import customer_restaurant_order_detailReducer from './slices/Order/CustomerRestaurantOrderDetailSlice';
import customerRestaurantDetailReducer from './slices/User/Detail/CustomerRestaurantDetailSlice';
import changeOrderStatusReducer from './slices/User/Detail/ChangeOrderStatusSlice';
import editMenuReducer from './slices/Menu/EditMenuSlice';
import deleteMenuReducer from './slices/Menu/DeleteMenuSlice';
import editNewsAndEventsReducer from './slices/NewsAndEvents/EditNewsAndEventsSlice';
import addFoodCategoriesReducer from './slices/Content/AddFoodCategoriesSlice'
import foodCategoriesReducer from './slices/Content/GetFoodCategoriesSlice'
import getFoodCategoryDropdownReducer from './slices/Content/GetFoodCategoriesListSlice'
import deleteFoodCategoryReducer from './slices/Content/DeleteFoodCategoriesSlice'
import addUnitsReducer from './slices/Content/AddUnitSlice';
import getUnitsListContentReducer from './slices/Content/GetUnitsListContentSlice';
import newsAndEventsDetailReducer from './slices/NewsAndEvents/DetailSlice';
import deleteProductReducer from './slices/Product/DeleteProductSlice';
import getReportsReducer from './slices/Query/GetReportsSlice';
import customerRestaurantCompleteOrdersReducer from './slices/User/Detail/GetCustomerRestaurantCompletedOrdersSlice';
import deleteQueryReducer from './slices/Query/DeleteQuerySlice';
import deleteReportsReducer from './slices/Query/DeleteReportsSlice';
import deleteNewsAndEventsReducer from './slices/NewsAndEvents/DeleteNewsAndEventsSlice';
import getNotificationReducer from './slices/Notification/GetNotificationSlice';
import updateFoodCategoriesReducer from './slices/Content/UpdateFoodCategoriesSlice';
import dayReducer from './slices/Filters/DaySlice';
import getProductTypeRegisterReducer from './slices/Supplier/GetProductTypeSlice';
import registerSupplierReducer from './slices/Supplier/RegisterSupplierSlice'


// Configure persistence only for cartUI
const cartUIPersistConfig = {
    key: 'cartUI',
    storage,
};

const rootReducer = combineReducers({
    login: loginReducer,
    logout: logoutReducer,
    usersCount: usersCountReducer,
    usersList: usersListReducer,
    getUsersData: getUsersDataReducer,
    getOrdersList: getOrdersListReducer,
    ordersForSuppliers: ordersForSuppliersReducer,
    supplierOrdersDashboard: supplierOrdersDashboardReducer,
    getProfile: getProfileReducer,
    updateProfile: updateProfileReducer,
    search: searchReducer,
    status: statusReducer,
    activeTab: activeTabReducer,
    addProduct: addProductReducer,
    getCategoriesList: getCategoriesListReducer,
    getProductTypesList: getProductTypesListReducer,
    addUnits: addUnitsReducer,
    getUnitsList: getUnitsListReducer,
    getSupplierDetail: getSupplierDetailReducer,
    customerRestaurantDetail: customerRestaurantDetailReducer,
    customer_restaurant_order_detail: customer_restaurant_order_detailReducer,
    getSupplierProducts: getSupplierProductsReducer,
    cart: cartReducer,
    cartUI: persistReducer(cartUIPersistConfig, cartUIReducer), // persist only this one,
    getSupplierFilterProducts: getSupplierFilterProducts,
    getSupplierFilterCategories: getSupplierFilterCategories,
    addToCart: addToCartReducer,
    updateUserStatus: updateUserStatusReducer,
    productsAddedToCart: productsAddedToCartReducer,
    getUnitsListContent: getUnitsListContentReducer,
    orderRequest: orderRequestReducer,
    supplierGeneratedOrders: supplierGeneratedOrdersReducer,
    supplierRecievedOrders: supplierRecievedOrdersReducer,
    supplierCompletedOrders: supplierCompletedOrdersReducer,
    changeOrderStatus: changeOrderStatusReducer,
    productManagement: productManagementReducer,
    showAddProductButton: showAddProductButtonReducer,
    addMenu: AddMenuReducer,
    menuList: menuListReducer,
    editMenu: editMenuReducer,
    deleteMenu: deleteMenuReducer,
    newsAndEventsList: newsAndEventsListReducer,
    addNewsAndEvents: addNewsAndEventsReducer,
    editNewsAndEvents: editNewsAndEventsReducer,
    addFoodCategories: addFoodCategoriesReducer,
    foodCategories: foodCategoriesReducer,
    getFoodCategoryDropdown: getFoodCategoryDropdownReducer,
    deleteFoodCategory: deleteFoodCategoryReducer,
    categories: categoriesReducer,
    productTypes: productTypesReducer,
    updateContent: updateContentReducer,
    getContent: getContentReducer,
    addCategory: addCategoryReducer,
    updateCategory: updateCategoryReducer,
    addProducType: addProducTypeReducer,
    getQueries: getQueriesReducer,
    sendNotification: sendNotificationReducer,
    changePassword: changePasswordReducer,
    newsAndEventsDetail: newsAndEventsDetailReducer,
    deleteProduct: deleteProductReducer,
    getReports: getReportsReducer,
    customerRestaurantCompleteOrders: customerRestaurantCompleteOrdersReducer,
    deleteNewsAndEvents: deleteNewsAndEventsReducer,
    deleteQuery: deleteQueryReducer,
    deleteReports: deleteReportsReducer,
    getNotification: getNotificationReducer,
    updateFoodCategories: updateFoodCategoriesReducer,
    day: dayReducer,
    getProductTypeRegister: getProductTypeRegisterReducer,
    registerSupplier: registerSupplierReducer,
});

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // needed for redux-persist
        }),
});

export const persistor = persistStore(store);